import React from "react";
import UsersCommon from "../UsersMain";
import { useParams } from "react-router-dom";

function Users() {
  let {
    subnetId,
    locationId,
    useCaseId,
    tagId,
    productId,
    website,
  } = useParams();

  const type = "all";
  const title = "All Users";

  return (
    <UsersCommon
      type={type}
      title={title}
      subnetId={subnetId}
      locationId={locationId}
      useCaseId={useCaseId}
      productId={productId}
      website={website}
      tagId={tagId}
    />
  );
}

export default Users;
